import { SORTING_KEYS } from '../constants/sortingKeys';

export const getPaginationSorting = (sortingKey, item) => {
  const itemSortings = paginationSortings[item];
  if (itemSortings === null) {
    return null;
  }

  return itemSortings[sortingKey];
};

export const paginationSortings = {
  hearings: {
    [SORTING_KEYS.DEADLINE_SOONEST]: { Property: 'Deadline' },
    [SORTING_KEYS.DEADLINE_LATEST]: {
      Property: 'Deadline',
      Desc: true,
    },
    [SORTING_KEYS.RELEASE_SOONEST]: { Property: 'StartDate' },
    [SORTING_KEYS.RELEASE_LATEST]: {
      Property: 'StartDate',
      Desc: true,
    },
    [SORTING_KEYS.ALPHABETICAL]: { Property: 'Title' },
    [SORTING_KEYS.ALPHABETICAL_REVERSE]: {
      Property: 'Title',
      Desc: true,
    },
  },
};
